import React from "react";

interface HorizontalStackedBarProps {
    usedPct: number
    freePct: number
    usedColor?: string
    freeColor?: string
    className?: string
  }
  
  export const HorizontalStackedBar: React.FC<HorizontalStackedBarProps> = ({
    usedPct,
    freePct,
    usedColor = '#1e5c5c',
    freeColor = '#f2f2f2',
    className = '',
  }) => {
    // ensure percentages sum to 100 (or clamp)
    const total = usedPct + freePct
    const usedW = total > 0 ? (usedPct / total) * 100 : 0
    // const freeW = 100 - usedW
  
    return (
      <div
        className={`h-3 w-full flex overflow-hidden rounded ${className}`}
        style={{ backgroundColor: freeColor }}
      >
        <div
          className="h-full rounded-r-full"
          style={{
            width: `${usedW}%`,
            backgroundColor: usedColor,
          }}
        />
      </div>
    )
  }
  